import { render, staticRenderFns } from "./ReviewLargeFilesHarvester.vue?vue&type=template&id=f1023dd2&"
import script from "./ReviewLargeFilesHarvester.vue?vue&type=script&lang=ts&"
export * from "./ReviewLargeFilesHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports